import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { confirmDialog } from 'primereact/confirmdialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from "primereact/button";
import { motion } from 'framer-motion';
import { goToTop } from "../../../../../../../Components/goToTop";
import { getAppCurrencyType } from "../../../../../../../Utils/Common";
import { Priliminary, SowSection, SowSectionItemData, SowSubSection, SowSubSectionItemData, TenderSow } from "../../../../../../../Controllers/Types/Tender/tenderSow";
import { useAppSelector } from "../../../../../../../Controllers/hooks";
import { useThisTemplateApi } from "../../../../../../../Api/tenderApi";
import { ProjectTenderDetailInterface } from "../../../../../../../Controllers/Types/Tender/projectTenderDetailsInterface";
import { Toast } from "primereact/toast";

const TemplateSOW: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const itemData = location.state.datax as any
    const { pass_template, pass_tenderPart } = location.state || {};
    const template: TenderSow = pass_template;
    const tenderPart: ProjectTenderDetailInterface = pass_tenderPart;
    const currencySymbol = getAppCurrencyType();

    const toast = useRef<Toast>(null);


    const [showSideBar, setShowSideBar] = useState<boolean>(false);

    /* Cover page */
    const [showCoverPage, setShowCoverpage] = useState<boolean>(true);
    const [hasCoverPage, setHasCoverPage] = useState<boolean>(false);

    /* Section */
    const [showSection, setShowSection] = useState<boolean>(false);
    const [hasSection, setHasSection] = useState<boolean>(false);
    const [currentSection, setCurrentSection] = useState<SowSection | null>(null);
    const [toggledSection, setToggledSection] = useState<boolean>(false);

    /* Sub section */
    const [showSubSection, setShowSubSection] = useState<boolean>(false);
    const [hasSubSection, setHasSubSection] = useState<boolean>(false);
    const [toggledSubSection, setToggledSubSection] = useState<boolean>(false);
    const [currentSubSection, setCurrentSubSection] = useState<SowSubSection | null>(null);

    /* Section item */
    const [hasSectionItem, setHasSectionItem] = useState<boolean>(false);
    const [sectionItemData, setSectionItemData] = useState<SowSectionItemData[]>([]);

    /* Sub section item */
    const [showSubSectionItem, setShowSubSectionItem] = useState<boolean>(false);
    const [hasSubSectionItem, setHasSubSectionItem] = useState<boolean>(false);
    const [subSectionItemData, setSubSectionItemData] = useState<SowSubSectionItemData[]>([]);

    /* Preliminaries */
    const [showPreliminaries, setShowPreliminaries] = useState<boolean>(false);
    const [hasPreliminary, setHasPreliminary] = useState<boolean>(false);


    /* ********************************** For template sow ********************************** */
    useEffect(() => {

        if (template?.cover !== null) {
            setHasCoverPage(true);
        } else {
            setHasCoverPage(false);
        }

        if (template.section!.length > 0) {
            setHasSection(true);
        } else {
            setHasSection(false);
        }

        if (template.priliminary!.length > 0) {
            setHasPreliminary(true);
        } else {
            setHasPreliminary(false);
        }
    }, []);

    const handleUseTemplate = () => {
        confirmDialog({
            message: 'Are you sure you want to use this template?',
            header: 'Confirmation',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-success',
            accept: useTemplate,
        });
    }

    const useTemplate = async () => {
        const res = await useThisTemplateApi(tenderPart.project_tender_part_id, template.template_tender_id)

        if (res.status) {
            navigate(-2);

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Successfully apply this template.',
                    life: 3000
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to apply this template.',
                    life: 3000
                });
            }
        }
    }
    /* ************************************************************************************** */




    const handleShowCoverPage = () => {
        setShowCoverpage(true);

        setShowSection(false);
        setShowSubSection(false);
        setShowPreliminaries(false);
        setShowSubSectionItem(false);

        setToggledSection(false);
        setToggledSubSection(false);
    }
    /* **************************************************************************** */




    const handleShowSections = () => {
        setShowSection(true);
        setToggledSection(!toggledSection);

        setShowCoverpage(false);
        setShowSubSection(false);
        setShowPreliminaries(false);
        setShowSubSectionItem(false);
    }
    /* **************************************************************************** */


    /* ******************************** Sub Section ******************************* */
    const handleShowSubSection = async (section: SowSection) => {
        setCurrentSection(section);

        if (section?.sub_section_data?.length !== 0) {
            setHasSubSection(true);
            setToggledSubSection(!toggledSubSection);
        } else {
            setHasSubSection(false);
            setToggledSubSection(false);
        }

        if (section?.section_item_data?.length !== 0) {
            setHasSectionItem(true);
        } else {
            setHasSectionItem(false);
        }

        setShowSubSection(true);
        setShowSection(false);
        setShowCoverpage(false);
        setShowPreliminaries(false);
        setShowSubSectionItem(false);
        setToggledSection(true);
    }
    /* **************************************************************************** */


    /* ******************************** Section item ******************************* */
    useEffect(() => {
        if (hasSectionItem && currentSection?.section_item_data) {
            setSectionItemData(currentSection.section_item_data);
        }
    }, [hasSectionItem, currentSection?.section_item_data]);
    /* **************************************************************************** */


    /* ****************************** Sub section item **************************** */
    useEffect(() => {
        if (hasSubSectionItem && currentSubSection?.sub_section_item_data) {
            setSubSectionItemData(currentSubSection.sub_section_item_data!);
        }
    }, [hasSubSectionItem, currentSubSection?.sub_section_item_data]);

    const handleShowSubSectionItem = async (subSection: SowSubSection) => {
        setCurrentSubSection(subSection)

        if (subSection?.sub_section_item_data?.length !== 0) {
            setHasSubSectionItem(true);
        } else {
            setHasSubSectionItem(false);
        }

        setShowSubSectionItem(true);
        setShowSection(false);
        setShowCoverpage(false);
        setShowPreliminaries(false);
        setShowSubSection(false);
    }
    /* **************************************************************************** */



    const handleShowPreliminaries = () => {
        setShowPreliminaries(true);

        setShowSection(false);
        setShowCoverpage(false);
        setShowSubSection(false);
        setShowSubSectionItem(false);

        setToggledSection(false);
        setToggledSubSection(false);
    }
    /* **************************************************************************** */


    /* **************************** Common functions ***************************** */
    const getRowClassName = () => {
        return 'project_table_row';
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    const handleShowSideBar = () => {
        setShowSideBar(!showSideBar);
    }
    /* *************************************************************************** */

    return (
        <div>
            <Toast ref={toast} />

            <div className="project_toolbar">
                <Button icon={`bi ${showSideBar ? 'bi-arrow-left' : 'bi-list'}`} onClick={handleShowSideBar} className="sidebar_toggle_btn" />
                <div className="project_tool_options mobile_wrap">
                    <div className="project_tool_options_sub">
                        <button className={`is_btn project_tool_btn p-ripple`}
                            onClick={handleUseTemplate}>
                            Use this template
                            {<Ripple />}
                        </button>
                    </div>
                    <div className="project_tool_options_sub">
                        <button className={`is_btn project_tool_btn p-ripple`}
                            onClick={goBack}>
                            Back
                            <Ripple />
                        </button>
                    </div>
                </div>
            </div>

            <div className={`project_sidebar ${showSideBar ? 'show' : ''}`}>
                <ul className="section_list">
                    {/* Cover page */}
                    <li className="section_list_item">
                        <div className={`section_link_grp ${showCoverPage && 'active'}`}>
                            <i className={`bi bi-caret-right-fill section_link_icon ${!hasCoverPage && 'disabled'}`}></i>
                            <button className="section_link is_btn"
                                onClick={handleShowCoverPage}
                                disabled={!hasCoverPage}>
                                <span>Cover page</span>
                            </button>
                        </div>
                    </li>

                    {/* Contents */}
                    <li className="section_list_item">
                        <div className={`section_link_grp ${showSection && 'active'} ${toggledSection && template.section!.length > 0 && 'has_child'} `}>
                            <i className={`bi bi-caret-right-fill section_link_icon ${!hasSection && 'disabled'}`}></i>
                            <button className="section_link is_btn"
                                onClick={handleShowSections}
                                disabled={!hasSection}>
                                <span>Contents</span>
                            </button>
                        </div>

                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{
                                height: toggledSection ? 'auto' : 0,
                                opacity: toggledSection ? 1 : 0,
                            }}
                            transition={{ duration: 0.5, ease: 'easeInOut' }}
                            style={{ overflow: 'hidden' }}
                        >
                            {template!.section!.length > 0 && (
                                <ul className="section_sub_list">
                                    {template!.section!.map((section) => (
                                        <li key={section.section_id} className="section_sub_list_item">
                                            <div className={`section_link_grp ${showSubSection && section.section_id === currentSection?.section_id && 'active'} ${toggledSubSection && section?.sub_section_data?.length! > 0 && 'has_child'} `}>
                                                <i className={`bi bi-caret-right section_link_icon ${(section?.sub_section_data?.length === 0 && section?.section_item_data?.length === 0) && 'disabled'}`}></i>
                                                <button className="section_link is_btn"
                                                    onClick={() => handleShowSubSection(section)}
                                                    disabled={section?.sub_section_data?.length === 0 && section?.section_item_data?.length === 0}>
                                                    <span>Section {section.section_no}</span>
                                                </button>
                                            </div>

                                            <motion.div
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{
                                                    height: toggledSubSection ? 'auto' : 0,
                                                    opacity: toggledSubSection ? 1 : 0,
                                                }}
                                                transition={{ duration: 0.5, ease: 'easeInOut' }}
                                                style={{ overflow: 'hidden' }}
                                            >
                                                {section?.sub_section_data?.length! > 0 && (
                                                    <ul className="section_sub_list_sub">
                                                        {section.sub_section_data?.map((sub_section) => (
                                                            <li className="section_sub_list_item_sub">
                                                                <div className={`section_link_grp ${showSubSectionItem && sub_section.sub_section_id === currentSubSection?.sub_section_id && 'active'} `}>
                                                                    <small className={`${sub_section?.sub_section_item_data?.length === 0 && 'disabled'}`}>{sub_section.sub_section_no}</small>
                                                                    <button className="section_link is_btn"
                                                                        onClick={() => handleShowSubSectionItem(sub_section)}
                                                                        disabled={sub_section?.sub_section_item_data?.length === 0}>
                                                                        <span>{sub_section.sub_section_name}</span>
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </motion.div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </motion.div>
                    </li>

                    {/* Preliminaries */}
                    <li className="section_list_item">
                        <div className={`section_link_grp ${showPreliminaries && 'active'} `}>
                            <i className={`bi bi-caret-right-fill section_link_icon ${!hasPreliminary && 'disabled'}`}></i>
                            <button className="section_link is_btn"
                                onClick={handleShowPreliminaries}
                                disabled={!hasPreliminary}>
                                <span>Preliminaries</span>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>

            <div className={`layout_backdrop ${showSideBar ? 'show' : ''}`} onClick={handleShowSideBar}></div>

            <div className={`project_main_content ${showSideBar ? 'has_sidebar' : ''}`}>
                {showCoverPage && (
                    <article className="main_section_area d-flex">
                        {hasCoverPage ? (
                            <div className="cover_page_area">
                                <img src={template?.logo} alt={template?.name} />

                                <h5>At</h5>
                                <h5>{template?.cover?.project_address}</h5>
                                <br />
                                <h5>For <br />
                                    {template?.cover?.client_name}
                                </h5>
                            </div>
                        ) : (
                            <div className="no_content_added_area">
                                <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                <p>Note : No cover page found!</p>
                            </div>
                        )}
                    </article>
                )}

                {showSection && (
                    <article className="main_section_area">
                        {hasSection ? (
                            <React.Fragment>
                                {template!.section!.length > 0 && (
                                    <DataTable
                                        value={template!.section!}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table p-0 p-sm-2"
                                        rowHover
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        dataKey="section_id"
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Section no"
                                            alignHeader={'center'}
                                            body={(rowData) => rowData.section_no ? <span className="flex_center">{rowData.section_no}</span> : '--'}
                                            style={{ width: '15%' }}
                                            className="table_column"
                                        ></Column>
                                        <Column
                                            header="Content"
                                            body={(rowData) => rowData.section_name ? <span>{rowData.section_name}</span> : '--'}
                                            style={{ width: '65%' }}
                                            className="table_column"
                                        ></Column>
                                        <Column
                                            header="Price"
                                            alignHeader={'right'}
                                            body={
                                                <span className="flex-end text-end text_no_wrap">
                                                    {currencySymbol}&nbsp;0.00
                                                </span>}
                                            style={{ width: '20%' }}
                                            className="table_column text-end"
                                        ></Column>
                                    </DataTable>
                                )}
                            </React.Fragment>
                        ) : (
                            <div className="no_content_added_area">
                                <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                <p>Note : No section(s) found!</p>
                            </div>
                        )}
                    </article>
                )}

                {showSubSection && (
                    <article className="main_section_area">
                        {currentSection && (
                            <div className="main_section_header">
                                <h6>{currentSection?.section_no}.&nbsp;&nbsp;{currentSection?.section_name}</h6>
                            </div>
                        )}

                        {hasSubSection && (
                            <React.Fragment>
                                {currentSection?.sub_section_data && (
                                    <DataTable
                                        value={currentSection?.sub_section_data}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table p-0 p-sm-2"
                                        rowHover
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        dataKey="sub_section_id"
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Sub section no."
                                            alignHeader={'center'}
                                            body={(rowData) => rowData.sub_section_no ? <span className="flex_center">{rowData.sub_section_no}</span> : '--'}
                                            style={{ width: '15%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Sub section name"
                                            body={(rowData) => rowData.sub_section_name ? <span>{rowData.sub_section_name}</span> : '--'}
                                            style={{ width: '65%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Price"
                                            alignHeader={'right'}
                                            body={
                                                <span className="flex-end text-end text_no_wrap">
                                                    {currencySymbol}&nbsp;0.00
                                                </span>}
                                            style={{ width: '20%' }}
                                            className="table_column text-end"
                                        ></Column>
                                    </DataTable>
                                )}
                            </React.Fragment>
                        )}

                        {hasSectionItem && (
                            <React.Fragment>
                                {currentSection?.section_item_data && (
                                    <DataTable
                                        value={sectionItemData}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table p-0 p-sm-2"
                                        rowHover
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        dataKey="item_id"
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Item no."
                                            alignHeader={'center'}
                                            body={(rowData) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                            style={{ width: '8%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Item name"
                                            body={(rowData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                            style={{ width: '30%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Unit no."
                                            alignHeader={'center'}
                                            style={{ width: '10%' }}
                                            className="table_column column_editable"
                                        ></Column>

                                        <Column
                                            header="Unit price"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end"
                                        ></Column>

                                        <Column
                                            header="Sub total"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end"
                                        ></Column>

                                        <Column
                                            header="Note"
                                            alignHeader={'center'}
                                            style={{ width: '28%' }}
                                            className="table_column"
                                        ></Column>
                                    </DataTable>
                                )}
                            </React.Fragment>
                        )}

                        {!hasSubSection && !hasSectionItem && (
                            <div className="no_content_added_area">
                                <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                <p>Note: No item(s) found!</p>
                            </div>
                        )}
                    </article>
                )}

                {showSubSectionItem && (
                    <article className="main_section_area">
                        {currentSubSection && (
                            <div className="main_section_header">
                                <h6>{currentSubSection?.sub_section_no}.&nbsp;&nbsp;{currentSubSection?.sub_section_name}</h6>
                            </div>
                        )}

                        {hasSubSectionItem ? (
                            <React.Fragment>
                                {currentSubSection?.sub_section_item_data && (
                                    <DataTable
                                        value={subSectionItemData}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table p-0 p-sm-2"
                                        rowHover
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        dataKey="item_id"
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Item no."
                                            alignHeader={'center'}
                                            body={(rowData: SowSectionItemData) => rowData.item_no ? <span className="flex_center">{rowData.item_no}</span> : '--'}
                                            style={{ width: '8%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Item name"
                                            body={(rowData: SowSectionItemData) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                            style={{ width: '30%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Unit no."
                                            alignHeader={'center'}
                                            style={{ width: '10%' }}
                                            className="table_column column_editable"
                                        ></Column>

                                        <Column
                                            header="Unit price"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end column_editable"
                                        ></Column>

                                        <Column
                                            header="Sub total"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end"
                                        ></Column>

                                        <Column
                                            header="Note"
                                            alignHeader={'center'}
                                            style={{ width: '28%' }}
                                            className="table_column"
                                        ></Column>
                                    </DataTable>
                                )}
                            </React.Fragment>
                        ) : (
                            <div className="no_content_added_area">
                                <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                <p>Note: No item(s) found!</p>
                            </div>
                        )}
                    </article>
                )}

                {showPreliminaries && (
                    <article className="main_section_area">
                        {hasPreliminary ? (
                            <React.Fragment>
                                {template?.priliminary!.length > 0 && (
                                    <DataTable
                                        value={template?.priliminary!}
                                        size="small"
                                        tableStyle={{ minWidth: '50rem' }}
                                        className="page_table project_table p-0 p-sm-2"
                                        rowHover
                                        tableClassName="mb-1"
                                        rowClassName={getRowClassName}
                                        dataKey="id"
                                        scrollable
                                        scrollHeight={'75vh'}
                                        emptyMessage="No data found"
                                    >
                                        <Column
                                            header="Ref no."
                                            alignHeader={'center'}
                                            body={(rowData: Priliminary) => rowData.ref_number ? <span className="flex_center">{rowData.ref_number}</span> : '--'}
                                            style={{ width: '8%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Item name"
                                            body={(rowData: Priliminary) => rowData.item_name ? <span>{rowData.item_name}</span> : '--'}
                                            style={{ width: '30%' }}
                                            className="table_column"
                                        ></Column>

                                        <Column
                                            header="Unit no."
                                            alignHeader={'center'}
                                            style={{ width: '10%' }}
                                            className="table_column text-center column_editable"
                                        ></Column>

                                        <Column
                                            header="Unit price"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column column_editable text-end"
                                        ></Column>

                                        <Column
                                            header="Sub total"
                                            alignHeader={'right'}
                                            style={{ width: '12%' }}
                                            className="table_column text-end"
                                        ></Column>

                                        <Column
                                            header="Note"
                                            alignHeader={'center'}
                                            style={{ width: '28%' }}
                                            className="table_column"
                                        ></Column>
                                    </DataTable>
                                )}
                            </React.Fragment>
                        ) : (
                            <div className="no_content_added_area">
                                <img src="/assets/images/no_data/no_data_img.png" alt="No data!" />
                                <p>Note : No preliminaries item(s) found!</p>
                            </div>
                        )}
                    </article>
                )}
            </div>
        </div >
    )
}

export default TemplateSOW;